import {
        CREATECOMPLAINTSYMPTOMSASSOCIATED,
        CREATEPEDIATRICCOMPLAINTANTENATALILLNESS,
        CREATEPEDIATRICCOMPLAINTANTENATALINFECTIONS,
        CREATEPEDIATRICCOMPLAINTANTENATALPREGANANCY,
        CREATEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY,
        CREATEPEDIATRICCOMPLAINTFEEDINGHISTORY,
        CREATEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT,
        CREATEPEDIATRICCOMPLAINTGENERALENQUIRY,
        CREATEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES,
        CREATEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY,
        CREATEPEDIATRICCOMPLAINTNATALDELIVERYTYPE,
        CREATEPEDIATRICCOMPLAINTNATALHISTORY,
        CREATEPEDIATRICCOMPLAINTPASTCOMORBIDITY,
        CREATEPEDIATRICCOMPLAINTPASTILLNESS,
        CREATEPEDIATRICCOMPLAINTPASTSYMPTOMS,
        CREATEPEDIATRICCOMPLAINTPOSTNATAL,
        CREATEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM,
        CREATEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY,
        CREATEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES,
        CREATEPEDIATRICCOMPLAINTSYSTEMICENQUIRY,
        CREATEPEDIATRICPAINASSESSMENTBODYCHARTOPD,
        CREATEPEDIATRICPAINASSESSMENTOPD,
        CREATEPRESENTCOPLAINTSCOMORBIDITY,
        CREATEPRESENTCOPLAINTSSYMTOMS,
        DELETECOMPLAINTSYMPTOMSASSOCIATED,
        DELETEPEDIATRICCOMPLAINTANTENATALILLNESS,
        DELETEPEDIATRICCOMPLAINTANTENATALINFECTIONS,
        DELETEPEDIATRICCOMPLAINTANTENATALPREGANANCY,
        DELETEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY,
        DELETEPEDIATRICCOMPLAINTFEEDINGHISTORY,
        DELETEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT,
        DELETEPEDIATRICCOMPLAINTGENERALENQUIRY,
        DELETEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES,
        DELETEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY,
        DELETEPEDIATRICCOMPLAINTNATALDELIVERYTYPE,
        DELETEPEDIATRICCOMPLAINTNATALHISTORY,
        DELETEPEDIATRICCOMPLAINTPASTCOMORBIDITY,
        DELETEPEDIATRICCOMPLAINTPASTILLNESS,
        DELETEPEDIATRICCOMPLAINTPASTSYMPTOMS,
        DELETEPEDIATRICCOMPLAINTPOSTNATAL,
        DELETEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM,
        DELETEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY,
        DELETEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES,
        DELETEPEDIATRICCOMPLAINTSYSTEMICENQUIRY,
        DELETEPEDIATRICPAINASSESSMENTBODYCHARTOPD,
        DELETEPEDIATRICPAINASSESSMENTOPD,
        DELETEPRESENTCOPLAINTSCOMORBIDITY,
        DELETEPRESENTCOPLAINTSSYMTOMS,
        GETCOMPLAINTSYMPTOMSASSOCIATED,
        GETPEDIATRICCOMPLAINTANTENATALILLNESS,
        GETPEDIATRICCOMPLAINTANTENATALINFECTIONS,
        GETPEDIATRICCOMPLAINTANTENATALPREGANANCY,
        GETPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY,
        GETPEDIATRICCOMPLAINTFEEDINGHISTORY,
        GETPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT,
        GETPEDIATRICCOMPLAINTGENERALENQUIRY,
        GETPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES,
        GETPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY,
        GETPEDIATRICCOMPLAINTNATALDELIVERYTYPE,
        GETPEDIATRICCOMPLAINTNATALHISTORY,
        GETPEDIATRICCOMPLAINTPASTCOMORBIDITY,
        GETPEDIATRICCOMPLAINTPASTILLNESS,
        GETPEDIATRICCOMPLAINTPASTSYMPTOMS,
        GETPEDIATRICCOMPLAINTPOSTNATAL,
        GETPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM,
        GETPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY,
        GETPEDIATRICCOMPLAINTPOSTNATALPROCEDURES,
        GETPEDIATRICCOMPLAINTSYSTEMICENQUIRY,
        GETPEDIATRICPAINASSESSMENTBODYCHARTOPD,
        GETPEDIATRICPAINASSESSMENTOPD,
        GETPRESENTCOPLAINTSCOMORBIDITY,
        GETPRESENTCOPLAINTSSYMTOMS,
        UPDATECOMPLAINTSYMPTOMSASSOCIATED,
        UPDATEPEDIATRICCOMPLAINTANTENATALILLNESS,
        UPDATEPEDIATRICCOMPLAINTANTENATALINFECTIONS,
        UPDATEPEDIATRICCOMPLAINTANTENATALPREGANANCY,
        UPDATEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY,
        UPDATEPEDIATRICCOMPLAINTFEEDINGHISTORY,
        UPDATEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT,
        UPDATEPEDIATRICCOMPLAINTGENERALENQUIRY,
        UPDATEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES,
        UPDATEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY,
        UPDATEPEDIATRICCOMPLAINTNATALDELIVERYTYPE,
        UPDATEPEDIATRICCOMPLAINTNATALHISTORY,
        UPDATEPEDIATRICCOMPLAINTPASTCOMORBIDITY,
        UPDATEPEDIATRICCOMPLAINTPASTILLNESS,
        UPDATEPEDIATRICCOMPLAINTPASTSYMPTOMS,
        UPDATEPEDIATRICCOMPLAINTPOSTNATAL,
        UPDATEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM,
        UPDATEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY,
        UPDATEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES,
        UPDATEPEDIATRICCOMPLAINTSYSTEMICENQUIRY,
        UPDATEPEDIATRICPAINASSESSMENTBODYCHARTOPD,
        UPDATEPEDIATRICPAINASSESSMENTOPD,
        UPDATEPRESENTCOPLAINTSCOMORBIDITY,
        UPDATEPRESENTCOPLAINTSSYMTOMS,
        CREATEPEDIATRICCOMPLAINTPERSONALHISTORY,
        GETPEDIATRICCOMPLAINTPERSONALHISTORY,
        DELETEPEDIATRICCOMPLAINTPERSONALHISTORY,
        UPDATEPEDIATRICCOMPLAINTPERSONALHISTORY,
        CREATEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE,
        GETPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE,
        DELETEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE,
        UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE,
        CREATEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT,
        GETPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT,
        DELETEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT,
        UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT,
        CREATEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL,
        GETPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL,
        DELETEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL,
        UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL,
        CREATEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP,
        GETPEDIATRICCOMPLAINTPERSONALHISTORYSLIP,
        DELETEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP,
        UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP,
        CREATEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK,
        GETPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK,
        DELETEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK,
        UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK,
        CREATEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK,
        GETPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK,
        DELETEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK,
        UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK,
        CREATEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE,
        GETPEDIATRICCOMPLAINTPERSONALHISTORYNATURE,
        DELETEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE,
        UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE,
        CREATEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY,
        GETPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY,
        DELETEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY,
        UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY,
        CREATEPEDIATRICCOMPLAINTFAMILYHISTORY,
        GETPEDIATRICCOMPLAINTFAMILYHISTORY,
        DELETEPEDIATRICCOMPLAINTFAMILYHISTORY,
        UPDATEPEDIATRICCOMPLAINTFAMILYHISTORY,
        CREATEPEDIATRICCOMPLAINTSYMPTOMSHISTORY,
        GETPEDIATRICCOMPLAINTSYMPTOMSHISTORY,
        DELETEPEDIATRICCOMPLAINTSYMPTOMSHISTORY,
        UPDATEPEDIATRICCOMPLAINTSYMPTOMSHISTORY,
        CREATEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY,
        GETPEDIATRICCOMPLAINTCOMORBIDITYHISTORY,
        DELETEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY,
        UPDATEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY,
        CREATEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY,
        GETPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY,
        DELETEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY,
        UPDATEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY,
        CREATEPEDIATRICEXAMINATION,
        GETPEDIATRICEXAMINATION,
        DELETEPEDIATRICEXAMINATION,
        UPDATEPEDIATRICEXAMINATION,
        CREATEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE,
        GETPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE,
        DELETEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE,
        UPDATEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE,
        CREATEPEDIATRICEXAMINATIONNUTRITION,
        GETPEDIATRICEXAMINATIONNUTRITION,
        DELETEPEDIATRICEXAMINATIONNUTRITION,
        UPDATEPEDIATRICEXAMINATIONNUTRITION,
        CREATEPEDIATRICEXAMINATIONANAEMIA,
        GETPEDIATRICEXAMINATIONANAEMIA,
        DELETEPEDIATRICEXAMINATIONANAEMIA,
        UPDATEPEDIATRICEXAMINATIONANAEMIA,
        CREATEPEDIATRICEXAMINATIONNECKVEIN,
        GETPEDIATRICEXAMINATIONNECKVEIN,
        DELETEPEDIATRICEXAMINATIONNECKVEIN,
        UPDATEPEDIATRICEXAMINATIONNECKVEIN,
        CREATEPEDIATRICEXAMINATIONLYMPHNODES,
        GETPEDIATRICEXAMINATIONLYMPHNODES,
        DELETEPEDIATRICEXAMINATIONLYMPHNODES,
        UPDATEPEDIATRICEXAMINATIONLYMPHNODES,
        CREATEPEDIATRICEXAMINATIONVITALS,
        GETPEDIATRICEXAMINATIONVITALS,
        DELETEPEDIATRICEXAMINATIONVITALS,
        UPDATEPEDIATRICEXAMINATIONVITALS,
        CREATEPEDIATRICEXAMINATIONGENERALAPPEARANCE,
        GETPEDIATRICEXAMINATIONGENERALAPPEARANCE,
        DELETEPEDIATRICEXAMINATIONGENERALAPPEARANCE,
        UPDATEPEDIATRICEXAMINATIONGENERALAPPEARANCE,
        CREATEPEDIATRICEXAMINATIONSKIN,
        GETPEDIATRICEXAMINATIONSKIN,
        DELETEPEDIATRICEXAMINATIONSKIN,
        UPDATEPEDIATRICEXAMINATIONSKIN,
        CREATEPEDIATRICEXAMINATIONHEENT,
        GETPEDIATRICEXAMINATIONHEENT,
        DELETEPEDIATRICEXAMINATIONHEENT,
        UPDATEPEDIATRICEXAMINATIONHEENT,
        CREATEPEDIATRICEXAMINATIONCHEST,
        GETPEDIATRICEXAMINATIONCHEST,
        DELETEPEDIATRICEXAMINATIONCHEST,
        UPDATEPEDIATRICEXAMINATIONCHEST,
        CREATEPEDIATRICEXAMINATIONABDOMEN,
        GETPEDIATRICEXAMINATIONABDOMEN,
        DELETEPEDIATRICEXAMINATIONABDOMEN,
        UPDATEPEDIATRICEXAMINATIONABDOMEN,
        CREATEPEDIATRICEXAMINATIONMSK,
        GETPEDIATRICEXAMINATIONMSK,
        DELETEPEDIATRICEXAMINATIONMSK,
        UPDATEPEDIATRICEXAMINATIONMSK,
        CREATEPEDIATRICEXAMINATIONNEURO,
        GETPEDIATRICEXAMINATIONNEURO,
        DELETEPEDIATRICEXAMINATIONNEURO,
        UPDATEPEDIATRICEXAMINATIONNEURO,
        CREATEOPDOUTPEDIATRICVACCINE,
        GETOPDOUTPEDIATRICVACCINE,
        UPDATEOPDOUTPEDIATRICVACCINE,
        DELETEOPDOUTPEDIATRICVACCINE,
        CREATEOPDOUTPEDIATRICDIETCHART,
        GETOPDOUTPEDIATRICDIETCHART,
        UPDATEOPDOUTPEDIATRICDIETCHART,
        DELETEOPDOUTPEDIATRICDIETCHART,
        CREATEOPDOUTPEDIATRICDIETCHARTSELECTION,
        GETOPDOUTPEDIATRICDIETCHARTSELECTION,
        UPDATEOPDOUTPEDIATRICDIETCHARTSELECTION,
        DELETEOPDOUTPEDIATRICDIETCHARTSELECTION,
        CREATEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT,
        GETOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT,
        UPDATEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT,
        DELETEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT,
        CREATEOPDOUTPEDIATRICDIETCHARTDAILYDIET,
        GETOPDOUTPEDIATRICDIETCHARTDAILYDIET,
        UPDATEOPDOUTPEDIATRICDIETCHARTDAILYDIET,
        DELETEOPDOUTPEDIATRICDIETCHARTDAILYDIET,
        CREATEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE,
        GETOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE,
        UPDATEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE,
        DELETEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE,
        CREATEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE,
        GETOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE,
        UPDATEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE,
        DELETEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE,
        CREATEOPDOUTEXERCISE,
        GETOPDOUTEXERCISE,
        UPDATEOPDOUTEXERCISE,
        DELETEOPDOUTEXERCISE,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

        switch (action.type) {

                case CREATEOPDOUTEXERCISE:
                        return {
                                ...state,
                                opdexercisechartSaveStatus: action.payload.success,
                        };

                case GETOPDOUTEXERCISE:
                        return {
                                ...state,
                                opdexercisechartList: action.payload.data,
                        };

                case DELETEOPDOUTEXERCISE:
                        return {
                                ...state,
                                opdexercisechartDeleteStatus: action.payload.success,
                        };
                case UPDATEOPDOUTEXERCISE:
                        return {
                                ...state,
                                opdexercisechartUpdateStatus: action.payload.success,
                        };

                case CREATEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE:
                        return {
                                ...state,
                                pediatricdietchartcustomtexttemplateSaveStatus: action.payload.success,
                        };

                case GETOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE:
                        return {
                                ...state,
                                pediatricdietchartcustomtexttemplateList: action.payload.data,
                        };

                case DELETEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE:
                        return {
                                ...state,
                                pediatricdietchartcustomtexttemplateDeleteStatus: action.payload.success,
                        };
                case UPDATEOPDOUTPEDIATRICDIETCHARTCUSTOMTEXTTEMPLATE:
                        return {
                                ...state,
                                pediatricdietchartcustomtexttemplateUpdateStatus: action.payload.success,
                        };

                case CREATEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE:
                        return {
                                ...state,
                                pediatricdietchartdailydiettemplateSaveStatus: action.payload.success,
                        };

                case GETOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE:
                        return {
                                ...state,
                                pediatricdietchartdailydiettemplateList: action.payload.data,
                        };
                case DELETEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE:
                        return {
                                ...state,
                                pediatricdietchartdailydiettemplateDeleteStatus: action.payload.success,
                        };
                case UPDATEOPDOUTPEDIATRICDIETCHARTDAILYDIETTEMPLATE:
                        return {
                                ...state,
                                pediatricdietchartdailydiettemplateUpdateStatus: action.payload.success,
                        };

                case CREATEOPDOUTPEDIATRICDIETCHARTDAILYDIET:
                        return {
                                ...state,
                                pediatricdietchartdailydietSaveStatus: action.payload.success,
                        };

                case GETOPDOUTPEDIATRICDIETCHARTDAILYDIET:
                        return {
                                ...state,
                                pediatricdietchartdailydietList: action.payload.data,
                        };
                case DELETEOPDOUTPEDIATRICDIETCHARTDAILYDIET:
                        return {
                                ...state,
                                pediatricdietchartdailydietDeleteStatus: action.payload.success,
                        };
                case UPDATEOPDOUTPEDIATRICDIETCHARTDAILYDIET:
                        return {
                                ...state,
                                pediatricdietchartdailydietUpdateStatus: action.payload.success,
                        };

                case CREATEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT:
                        return {
                                ...state,
                                pediatricdietchartcustometextSaveStatus: action.payload.success,
                        };

                case GETOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT:
                        return {
                                ...state,
                                pediatricdietchartcustometextList: action.payload.data,
                        };
                case DELETEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT:
                        return {
                                ...state,
                                pediatricdietchartcustometextDeleteStatus: action.payload.success,
                        };
                case UPDATEOPDOUTPEDIATRICDIETCHARTCUSTOMETEXT:
                        return {
                                ...state,
                                pediatricdietchartcustometextUpdateStatus: action.payload.success,
                        };

                case CREATEOPDOUTPEDIATRICDIETCHARTSELECTION:
                        return {
                                ...state,
                                pediatricdietchartselectionSaveStatus: action.payload.success,
                        };

                case GETOPDOUTPEDIATRICDIETCHARTSELECTION:
                        return {
                                ...state,
                                pediatricdietchartselectionList: action.payload.data,
                        };
                case DELETEOPDOUTPEDIATRICDIETCHARTSELECTION:
                        return {
                                ...state,
                                pediatricdietchartselectionDeleteStatus: action.payload.success,
                        };
                case UPDATEOPDOUTPEDIATRICDIETCHARTSELECTION:
                        return {
                                ...state,
                                pediatricdietchartselectionUpdateStatus: action.payload.success,
                        };

                case CREATEOPDOUTPEDIATRICDIETCHART:
                        return {
                                ...state,
                                pediatricdietchartSaveStatus: action.payload.success,
                        };
                case GETOPDOUTPEDIATRICDIETCHART:
                        return {
                                ...state,
                                pediatricdietchartList: action.payload.data,
                        };
                case DELETEOPDOUTPEDIATRICDIETCHART:
                        return {
                                ...state,
                                pediatricdietchartDeleteStatus: action.payload.success,
                        };
                case UPDATEOPDOUTPEDIATRICDIETCHART:
                        return {
                                ...state,
                                pediatricdietchartUpdateStatus: action.payload.success,
                        };

                case CREATEOPDOUTPEDIATRICVACCINE:
                        return {
                                ...state,
                                pediatricOpdOutImmunizationSaveStatus: action.payload.success,
                        };
                case GETOPDOUTPEDIATRICVACCINE:
                        return {
                                ...state,
                                pediatricOpdOutImmunizationList: action.payload.data,
                        };
                case DELETEOPDOUTPEDIATRICVACCINE:
                        return {
                                ...state,
                                pediatricOpdOutImmunizationDeleteStatus: action.payload.success,
                        };
                case UPDATEOPDOUTPEDIATRICVACCINE:
                        return {
                                ...state,
                                pediatricOpdOutImmunizationUpdateStatus: action.payload.success,
                        };


                case CREATEPEDIATRICEXAMINATIONGENERALAPPEARANCE:
                        return {
                                ...state,
                                pediatricExaminationGeneralAppearanceSaveStatus: action.payload.success,
                        };
                case GETPEDIATRICEXAMINATIONGENERALAPPEARANCE:
                        return {
                                ...state,
                                pediatricExaminationGeneralAppearanceList: action.payload.data,
                        };
                case DELETEPEDIATRICEXAMINATIONGENERALAPPEARANCE:
                        return {
                                ...state,
                                pediatricExaminationGeneralAppearanceDeleteStatus: action.payload.success,
                        };
                case UPDATEPEDIATRICEXAMINATIONGENERALAPPEARANCE:
                        return {
                                ...state,
                                pediatricExaminationGeneralAppearanceUpdateStatus: action.payload.success,
                        };

                case CREATEPEDIATRICEXAMINATIONSKIN:
                        return {
                                ...state,
                                pediatricExaminationSkinSaveStatus: action.payload.success,
                        };
                case GETPEDIATRICEXAMINATIONSKIN:
                        return {
                                ...state,
                                pediatricExaminationSkinList: action.payload.data,
                        };
                case DELETEPEDIATRICEXAMINATIONSKIN:
                        return {
                                ...state,
                                pediatricExaminationSkinDeleteStatus: action.payload.success,
                        };
                case UPDATEPEDIATRICEXAMINATIONSKIN:
                        return {
                                ...state,
                                pediatricExaminationSkinUpdateStatus: action.payload.success,
                        };

                case CREATEPEDIATRICEXAMINATIONHEENT:
                        return {
                                ...state,
                                pediatricExaminationHeentSaveStatus: action.payload.success,
                        };
                case GETPEDIATRICEXAMINATIONHEENT:
                        return {
                                ...state,
                                pediatricExaminationHeentList: action.payload.data,
                        };
                case DELETEPEDIATRICEXAMINATIONHEENT:
                        return {
                                ...state,
                                pediatricExaminationHeentDeleteStatus: action.payload.success,
                        };
                case UPDATEPEDIATRICEXAMINATIONHEENT:
                        return {
                                ...state,
                                pediatricExaminationHeentUpdateStatus: action.payload.success,
                        };

                case CREATEPEDIATRICEXAMINATIONCHEST:
                        return {
                                ...state,
                                pediatricExaminationChestSaveStatus: action.payload.success,
                        };
                case GETPEDIATRICEXAMINATIONCHEST:
                        return {
                                ...state,
                                pediatricExaminationChestList: action.payload.data,
                        };
                case DELETEPEDIATRICEXAMINATIONCHEST:
                        return {
                                ...state,
                                pediatricExaminationChestDeleteStatus: action.payload.success,
                        };
                case UPDATEPEDIATRICEXAMINATIONCHEST:
                        return {
                                ...state,
                                pediatricExaminationChestUpdateStatus: action.payload.success,
                        };

                case CREATEPEDIATRICEXAMINATIONABDOMEN:
                        return {
                                ...state,
                                pediatricExaminationAbdomenSaveStatus: action.payload.success,
                        };
                case GETPEDIATRICEXAMINATIONABDOMEN:
                        return {
                                ...state,
                                pediatricExaminationAbdomenList: action.payload.data,
                        };
                case DELETEPEDIATRICEXAMINATIONABDOMEN:
                        return {
                                ...state,
                                pediatricExaminationAbdomenDeleteStatus: action.payload.success,
                        };
                case UPDATEPEDIATRICEXAMINATIONABDOMEN:
                        return {
                                ...state,
                                pediatricExaminationAbdomenUpdateStatus: action.payload.success,
                        };

                case CREATEPEDIATRICEXAMINATIONMSK:
                        return {
                                ...state,
                                pediatricExaminationMskSaveStatus: action.payload.success,
                        };
                case GETPEDIATRICEXAMINATIONMSK:
                        return {
                                ...state,
                                pediatricExaminationMskList: action.payload.data,
                        };
                case DELETEPEDIATRICEXAMINATIONMSK:
                        return {
                                ...state,
                                pediatricExaminationMskDeleteStatus: action.payload.success,
                        };
                case UPDATEPEDIATRICEXAMINATIONMSK:
                        return {
                                ...state,
                                pediatricExaminationMskUpdateStatus: action.payload.success,
                        };

                case CREATEPEDIATRICEXAMINATIONNEURO:
                        return {
                                ...state,
                                pediatricExaminationNeuroSaveStatus: action.payload.success,
                        };
                case GETPEDIATRICEXAMINATIONNEURO:
                        return {
                                ...state,
                                pediatricExaminationNeuroList: action.payload.data,
                        };
                case DELETEPEDIATRICEXAMINATIONNEURO:
                        return {
                                ...state,
                                pediatricExaminationNeuroDeleteStatus: action.payload.success,
                        };
                case UPDATEPEDIATRICEXAMINATIONNEURO:
                        return {
                                ...state,
                                pediatricExaminationNeuroUpdateStatus: action.payload.success,
                        };

                case CREATEPEDIATRICEXAMINATIONVITALS:
                        return {
                                ...state,
                                pediatricexaminationvitalsSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICEXAMINATIONVITALS:
                        return {
                                ...state,
                                pediatricexaminationvitalsList: action.payload.data,
                        }

                case DELETEPEDIATRICEXAMINATIONVITALS:
                        return {
                                ...state,
                                pediatricexaminationvitalsDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICEXAMINATIONVITALS:
                        return {
                                ...state,
                                pediatricexaminationvitalsUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICEXAMINATIONLYMPHNODES:
                        return {
                                ...state,
                                pediatricexaminationlymphnodesSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICEXAMINATIONLYMPHNODES:
                        return {
                                ...state,
                                pediatricexaminationlymphnodesList: action.payload.data,
                        }

                case DELETEPEDIATRICEXAMINATIONLYMPHNODES:
                        return {
                                ...state,
                                pediatricexaminationlymphnodesDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICEXAMINATIONLYMPHNODES:
                        return {
                                ...state,
                                pediatricexaminationlymphnodesUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICEXAMINATIONNECKVEIN:
                        return {
                                ...state,
                                pediatricexaminationneckveinSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICEXAMINATIONNECKVEIN:
                        return {
                                ...state,
                                pediatricexaminationneckveinList: action.payload.data,
                        }

                case DELETEPEDIATRICEXAMINATIONNECKVEIN:
                        return {
                                ...state,
                                pediatricexaminationneckveinDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICEXAMINATIONNECKVEIN:
                        return {
                                ...state,
                                pediatricexaminationneckveinUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICEXAMINATIONANAEMIA:
                        return {
                                ...state,
                                pediatricexaminationanaemiaSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICEXAMINATIONANAEMIA:
                        return {
                                ...state,
                                pediatricexaminationanaemiaList: action.payload.data,
                        }

                case DELETEPEDIATRICEXAMINATIONANAEMIA:
                        return {
                                ...state,
                                pediatricexaminationanaemiaDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICEXAMINATIONANAEMIA:
                        return {
                                ...state,
                                pediatricexaminationanaemiaUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICEXAMINATIONNUTRITION:
                        return {
                                ...state,
                                pediatricexaminationnutritionSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICEXAMINATIONNUTRITION:
                        return {
                                ...state,
                                pediatricexaminationnutritionList: action.payload.data,
                        }

                case DELETEPEDIATRICEXAMINATIONNUTRITION:
                        return {
                                ...state,
                                pediatricexaminationnutritionDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICEXAMINATIONNUTRITION:
                        return {
                                ...state,
                                pediatricexaminationnutritionUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE:
                        return {
                                ...state,
                                pediatricexaminationgenerallookappearanceSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE:
                        return {
                                ...state,
                                pediatricexaminationgenerallookappearanceList: action.payload.data,
                        }

                case DELETEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE:
                        return {
                                ...state,
                                pediatricexaminationgenerallookappearanceDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICEXAMINATIONGENERALLOOKAPPEARANCE:
                        return {
                                ...state,
                                pediatricexaminationgenerallookappearanceUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICEXAMINATION:
                        return {
                                ...state,
                                pediatricexaminationSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICEXAMINATION:
                        return {
                                ...state,
                                pediatricexaminationList: action.payload.data,
                        }

                case DELETEPEDIATRICEXAMINATION:
                        return {
                                ...state,
                                pediatricexaminationDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICEXAMINATION:
                        return {
                                ...state,
                                pediatricexaminationUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorysocioeconomichistorySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorysocioeconomichistoryList: action.payload.data,
                        }

                case DELETEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorysocioeconomichistoryDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICCOMPLAINTSOCIOECONOMICHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorysocioeconomichistoryUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorycomorbidityhistorySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTCOMORBIDITYHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorycomorbidityhistoryList: action.payload.data,
                        }

                case DELETEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorycomorbidityhistoryDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICCOMPLAINTCOMORBIDITYHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorycomorbidityhistoryUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICCOMPLAINTSYMPTOMSHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorysymptomshistorySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTSYMPTOMSHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorysymptomshistoryList: action.payload.data,
                        }

                case DELETEPEDIATRICCOMPLAINTSYMPTOMSHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorysymptomshistoryDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICCOMPLAINTSYMPTOMSHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorysymptomshistoryUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICCOMPLAINTFAMILYHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistoryfamilyhistorySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTFAMILYHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistoryfamilyhistoryList: action.payload.data,
                        }

                case DELETEPEDIATRICCOMPLAINTFAMILYHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistoryfamilyhistoryDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICCOMPLAINTFAMILYHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistoryfamilyhistoryUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorydrughistorySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorydrughistoryList: action.payload.data,
                        }

                case DELETEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorydrughistoryDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYDRUGHISTORY:
                        return {
                                ...state,
                                pediatriccomplainthistorydrughistoryUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorynaturekSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPERSONALHISTORYNATURE:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorynaturekList: action.payload.data,
                        }

                case DELETEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorynaturekDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYNATURE:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorynaturekUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorypositionduringworkSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorypositionduringworkList: action.payload.data,
                        }

                case DELETEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorypositionduringworkDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYPOSITIONDURINGWORK:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorypositionduringworkUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryaddictionsandhighriskbehaviorSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryaddictionsandhighriskbehaviorList: action.payload.data,
                        }

                case DELETEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryaddictionsandhighriskbehaviorDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYADDICTIONSANDHIGHRISK:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryaddictionsandhighriskbehaviorUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryslipSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPERSONALHISTORYSLIP:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryslipList: action.payload.data,
                        }

                case DELETEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryslipDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYSLIP:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryslipUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorybowelSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorybowelList: action.payload.data,
                        }

                case DELETEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorybowelDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYBOWEL:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorybowelUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorydigestivetractSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorydigestivetractList: action.payload.data,
                        }

                case DELETEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorydigestivetractDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYDIGESTIVETRACT:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorydigestivetractUpdateStatus: action.payload.success,
                        }

                case CREATEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryappetiteSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryappetiteList: action.payload.data,
                        }

                case DELETEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryappetiteDeleteStatus: action.payload.success,
                        }

                case UPDATEPEDIATRICCOMPLAINTPERSONALHISTORYAPPETITLE:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryappetiteUpdateStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTPERSONALHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistorySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPERSONALHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTPERSONALHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTPERSONALHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintpersonalhistoryDeleteStatus: action.payload.success,
                        }

                case CREATEPEDIATRICPAINASSESSMENTOPD:
                        return {
                                ...state,
                                pediatripainassesmentopdSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICPAINASSESSMENTOPD:
                        return {
                                ...state,
                                pediatripainassesmentopdList: action.payload.data,
                        }
                case UPDATEPEDIATRICPAINASSESSMENTOPD:
                        return {
                                ...state,
                                pediatripainassesmentopdUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICPAINASSESSMENTOPD:
                        return {
                                ...state,
                                pediatripainassesmentopdDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICPAINASSESSMENTBODYCHARTOPD:
                        return {
                                ...state,
                                pediatripainassesmentbodychartopdSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICPAINASSESSMENTBODYCHARTOPD:
                        return {
                                ...state,
                                pediatripainassesmentbodychartopdList: action.payload.data,
                        }
                case UPDATEPEDIATRICPAINASSESSMENTBODYCHARTOPD:
                        return {
                                ...state,
                                pediatripainassesmentopdbodychartUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICPAINASSESSMENTBODYCHARTOPD:
                        return {
                                ...state,
                                pediatripainassesmentopdbadychartDeleteStatus: action.payload.success,
                        }
                case CREATEPRESENTCOPLAINTSSYMTOMS:
                        return {
                                ...state,
                                preseentcomplaintssymptomsSaveStatus: action.payload.success,
                        }
                case GETPRESENTCOPLAINTSSYMTOMS:
                        return {
                                ...state,
                                preseentcomplaintssymptomsList: action.payload.data,
                        }
                case UPDATEPRESENTCOPLAINTSSYMTOMS:
                        return {
                                ...state,
                                preseentcomplaintssymptomsUpdateStatus: action.payload.success,
                        }

                case DELETEPRESENTCOPLAINTSSYMTOMS:
                        return {
                                ...state,
                                preseentcomplaintssymptomsDeleteStatus: action.payload.success,
                        }
                case CREATEPRESENTCOPLAINTSCOMORBIDITY:
                        return {
                                ...state,
                                preseentcomplaintscomorbiditySaveStatus: action.payload.success,
                        }
                case GETPRESENTCOPLAINTSCOMORBIDITY:
                        return {
                                ...state,
                                preseentcomplaintscomorbidityList: action.payload.data,
                        }
                case UPDATEPRESENTCOPLAINTSCOMORBIDITY:
                        return {
                                ...state,
                                preseentcomplaintscomorbidityUpdateStatus: action.payload.success,
                        }

                case DELETEPRESENTCOPLAINTSCOMORBIDITY:
                        return {
                                ...state,
                                preseentcomplaintscomorbidityDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTGENERALENQUIRY:
                        return {
                                ...state,
                                pediatriccomplaintsgeneralenquirySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTGENERALENQUIRY:
                        return {
                                ...state,
                                pediatriccomplaintsgeneralenquiryList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTGENERALENQUIRY:
                        return {
                                ...state,
                                pediatriccomplaintsgeneralenquiryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTGENERALENQUIRY:
                        return {
                                ...state,
                                pediatriccomplaintsgeneralenquiryDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTSYSTEMICENQUIRY:
                        return {
                                ...state,
                                pediatriccomplaintsystemicenquirySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTSYSTEMICENQUIRY:
                        return {
                                ...state,
                                pediatriccomplaintsystemicenquiryList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTSYSTEMICENQUIRY:
                        return {
                                ...state,
                                pediatriccomplaintsystemicenquiryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTSYSTEMICENQUIRY:
                        return {
                                ...state,
                                pediatriccomplaintsystemicenquiryDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTANTENATALILLNESS:
                        return {
                                ...state,
                                pediatriccomplaintantenatalillnessSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTANTENATALILLNESS:
                        return {
                                ...state,
                                pediatriccomplaintantenatalillnessList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTANTENATALILLNESS:
                        return {
                                ...state,
                                pediatriccomplaintantenatalillnessUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTANTENATALILLNESS:
                        return {
                                ...state,
                                pediatriccomplaintantenatalillnessDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTANTENATALINFECTIONS:
                        return {
                                ...state,
                                pediatriccomplaintantenatalinfectionsSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTANTENATALINFECTIONS:
                        return {
                                ...state,
                                pediatriccomplaintantenatalinfectionsList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTANTENATALINFECTIONS:
                        return {
                                ...state,
                                pediatriccomplaintantenatalinfectionsUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTANTENATALINFECTIONS:
                        return {
                                ...state,
                                pediatriccomplaintantenatalinfectionsDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTANTENATALPREGANANCY:
                        return {
                                ...state,
                                pediatriccomplaintantenatalpregnancySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTANTENATALPREGANANCY:
                        return {
                                ...state,
                                pediatriccomplaintantenatalpregnancyList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTANTENATALPREGANANCY:
                        return {
                                ...state,
                                pediatriccomplaintantenatalpregnancyUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTANTENATALPREGANANCY:
                        return {
                                ...state,
                                pediatriccomplaintantenatalpregnancyDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTNATALDELIVERYTYPE:
                        return {
                                ...state,
                                pediatriccomplaintnataltypeofdeliverySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTNATALDELIVERYTYPE:
                        return {
                                ...state,
                                pediatriccomplaintnataltypeofdeliveryList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTNATALDELIVERYTYPE:
                        return {
                                ...state,
                                pediatriccomplaintnataltypeofdeliveryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTNATALDELIVERYTYPE:
                        return {
                                ...state,
                                pediatriccomplaintnataltypeofdeliveryDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTNATALHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintnatalhistorySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTNATALHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintnatalhistoryList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTNATALHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintnatalhistoryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTNATALHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintnatalhistoryDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalfirstcrySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalfirstcryList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalfirstcryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTPOSTNATALFIRSTCRY:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalfirstcryDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalbasicproblemSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalbasicproblemList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalbasicproblemUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTPOSTNATALBASICPROBLEM:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalbasicproblemDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalproceduresSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPOSTNATALPROCEDURES:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalproceduresList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalproceduresUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTPOSTNATALPROCEDURES:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalproceduresDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTPOSTNATAL:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalhistorySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPOSTNATAL:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalhistoryList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTPOSTNATAL:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalhistoryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTPOSTNATAL:
                        return {
                                ...state,
                                pediatriccomplaintpostnatalhistoryDeleteStatus: action.payload.success,
                        }
                case CREATECOMPLAINTSYMPTOMSASSOCIATED:
                        return {
                                ...state,
                                pediatriccomplaintsgeneralenquirysymptomsSaveStatus: action.payload.success,
                        }
                case GETCOMPLAINTSYMPTOMSASSOCIATED:
                        return {
                                ...state,
                                pediatriccomplaintsgeneralenquirysymptomsList: action.payload.data,
                        }
                case UPDATECOMPLAINTSYMPTOMSASSOCIATED:
                        return {
                                ...state,
                                pediatriccomplaintsgeneralenquirysymptomsUpdateStatus: action.payload.success,
                        }

                case DELETECOMPLAINTSYMPTOMSASSOCIATED:
                        return {
                                ...state,
                                pediatriccomplaintsgeneralenquirysymptomsDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT:
                        return {
                                ...state,
                                pediatriccomplaintfeedingsupplementsSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT:
                        return {
                                ...state,
                                pediatriccomplaintfeedingsupplementsList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT:
                        return {
                                ...state,
                                pediatriccomplaintfeedingsupplementsUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTFEEDINGSUPPLEMENT:
                        return {
                                ...state,
                                pediatriccomplaintfeedingsupplementsDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTFEEDINGHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintfeedinghistorySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTFEEDINGHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintfeedinghistoryList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTFEEDINGHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintfeedinghistoryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTFEEDINGHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintfeedinghistoryDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintdevelopmenthistorySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintdevelopmenthistoryList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintdevelopmenthistoryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTDEVOLOLMENTHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintdevelopmenthistoryDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintimmunizationhistorySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintimmunizationhistoryList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintimmunizationhistoryUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTIMMUNIZATIONHISTORYHISTORY:
                        return {
                                ...state,
                                pediatriccomplaintimmunizationhistoryDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES:
                        return {
                                ...state,
                                pediatriccomplaintimmunizationdosesSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES:
                        return {
                                ...state,
                                pediatriccomplaintimmunizationdosesList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES:
                        return {
                                ...state,
                                pediatriccomplaintimmunizationdosesUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTIMMUNIZATIONDOSESDOSES:
                        return {
                                ...state,
                                pediatriccomplaintimmunizationdosesDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTPASTILLNESS:
                        return {
                                ...state,
                                pediatriccomplaintpastillnessesSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPASTILLNESS:
                        return {
                                ...state,
                                pediatriccomplaintpastillnessesList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTPASTILLNESS:
                        return {
                                ...state,
                                pediatriccomplaintpastillnessesUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTPASTILLNESS:
                        return {
                                ...state,
                                pediatriccomplaintpastillnessesDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTPASTSYMPTOMS:
                        return {
                                ...state,
                                pediatriccomplaintpastsymptomsSaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPASTSYMPTOMS:
                        return {
                                ...state,
                                pediatriccomplaintpastsymptomsList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTPASTSYMPTOMS:
                        return {
                                ...state,
                                pediatriccomplaintpastsymptomsUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTPASTSYMPTOMS:
                        return {
                                ...state,
                                pediatriccomplaintpastsymptomsDeleteStatus: action.payload.success,
                        }
                case CREATEPEDIATRICCOMPLAINTPASTCOMORBIDITY:
                        return {
                                ...state,
                                pediatriccomplaintpastcomorbiditySaveStatus: action.payload.success,
                        }
                case GETPEDIATRICCOMPLAINTPASTCOMORBIDITY:
                        return {
                                ...state,
                                pediatriccomplaintpastcomorbidityList: action.payload.data,
                        }
                case UPDATEPEDIATRICCOMPLAINTPASTCOMORBIDITY:
                        return {
                                ...state,
                                pediatriccomplaintpastcomorbidityUpdateStatus: action.payload.success,
                        }

                case DELETEPEDIATRICCOMPLAINTPASTCOMORBIDITY:
                        return {
                                ...state,
                                pediatriccomplaintpastcomorbidityDeleteStatus: action.payload.success,
                        }
                default:
                        return state
        }
}